<div #swipeContainer>
  <mat-tab-group #tabGroup>
    <mat-tab label="Välkommen">
      <spb-welcome/>
    </mat-tab>

    <mat-tab label="Skanna">
      <ng-template matTabContent>
        <spb-scanner/>
      </ng-template>
    </mat-tab>

    <mat-tab label="Utförda">
      <ng-template matTabContent>
        <spb-id-list/>
      </ng-template>
    </mat-tab>

    <mat-tab label="Hjälp">
      <spb-help/>
    </mat-tab>
  </mat-tab-group>
</div>